import React, { useCallback, useState } from 'react';
import * as Styles from './InstallWhmcs.styles';
import {
  Button,
  Checkbox,
  IconData,
  IconLoading,
  Input,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale/useLocale';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';

export const InstallWhmcs = ({
  selectedProduct,
  opening,
  submitForm,
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const { installWhmcs: installWhmcsLocale } = ticketsLocale.forms;
  const [formData, setFormData] = useState({
    linkField: '',
    email: '',
    password: '',
    key: '',
    agreed: false,
  });

  const checkForm = useCallback(() => !(
    !!formData.linkField
    && !!formData.email
    && !!formData.password
    && !!formData.key
    && !!formData.agreed
  ), [formData]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    const data = {
      locale: ticketsLocale,
      automation: false,
      pid: selectedProduct.pid,
      product: selectedProduct.id,
      subject: ticketsLocale.forms.names.installWhmcs,
      server_value: selectedProduct.serverhostname,
      domain_value: selectedProduct.domain,
      key: V2Forms.INSTALL_WHMCS,
      tags: [
        'whmcs_form_tecnico_instalar_whmcs',
        selectedProduct.name.toLowerCase().replace(/ /g, '_'),
      ],
      body: `
        • ${installWhmcsLocale.body.product(selectedProduct)}
        • ${installWhmcsLocale.body.request}
        • ${installWhmcsLocale.body.link(formData.linkField)}
        • ${installWhmcsLocale.body.email(formData.email)}
        • ${installWhmcsLocale.body.password(formData.password)}
        • ${installWhmcsLocale.body.key(formData.key)}
        • ${installWhmcsLocale.body.agreed(formData.agreed)}
        • ${installWhmcsLocale.body.productId(selectedProduct)}
      `,
    };

    submitForm && submitForm(data);
  }, [
    ticketsLocale,
    selectedProduct,
    formData,
    submitForm,
    installWhmcsLocale,
  ]);

  const handleChange = useCallback(({ key, value }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  }, [
    formData,
  ]);

  return (
    <Styles.Form onSubmit={e => handleSubmit(e)}>
      <Styles.Info>
        <IconData />
        {installWhmcsLocale.info}
      </Styles.Info>

      <Styles.Title>
        {installWhmcsLocale.title}
      </Styles.Title>

      <Styles.InputsWrapper>
        <Styles.InputWrapper>
          <Input
            name="linkField"
            placeholder={installWhmcsLocale.placeholders.linkField}
            label={formData.linkField ? installWhmcsLocale.placeholders.linkField : ''}
            value={formData.linkField}
            onChange={e => handleChange({ key: 'linkField', value: e.target.value })}
            type="text"
            testId="linkField"
          />
          <Styles.InputInfoText>
            {installWhmcsLocale.placeholders.linkFieldInfo}
          </Styles.InputInfoText>
        </Styles.InputWrapper>

        <Input
          name="email"
          placeholder={installWhmcsLocale.placeholders.email}
          label={formData.email ? installWhmcsLocale.placeholders.email : ''}
          value={formData.email}
          onChange={e => handleChange({ key: 'email', value: e.target.value })}
          type="text"
          testId="email"
        />

        <Input
          name="password"
          placeholder={installWhmcsLocale.placeholders.password}
          label={formData.password ? installWhmcsLocale.placeholders.password : ''}
          value={formData.password}
          onChange={e => handleChange({ key: 'password', value: e.target.value })}
          type="password"
          testId="password"
        />

        <Input
          name="key"
          placeholder={installWhmcsLocale.placeholders.key}
          label={formData.key ? installWhmcsLocale.placeholders.key : ''}
          value={formData.key}
          onChange={e => handleChange({ key: 'key', value: e.target.value })}
          type="key"
          testId="key"
        />
      </Styles.InputsWrapper>

      <Styles.CheckboxLabel
        htmlFor="#readTerms"
        data-testid="checkReadTerms"
        onClick={() => handleChange({ key: 'agreed', value: !formData.agreed })}
      >
        <Checkbox checked={formData.agreed} id="readTerms" />
        <Styles.Text>
          {installWhmcsLocale.placeholders.agreed}
        </Styles.Text>
      </Styles.CheckboxLabel>

      <Styles.ButtonWrapper>
        <Button
          size="large"
          label={opening ? <IconLoading /> : installWhmcsLocale.send}
          disabled={checkForm() || opening}
          type="submit"
          testId="submit"
        />
      </Styles.ButtonWrapper>
    </Styles.Form>
  );
};

export default InstallWhmcs;
